const AllocationList = () => import("./views/AllocationList.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/allocation_list",
      component: AllocationList,
      name: "Allocation List",
      meta: {
        groupName: "Auction",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
